import React, { useCallback, useContext } from 'react'
import { SystemBtnsStyles } from './Style'
import { IconButton, SvgIcon } from '@mui/material'
import { SideBarContext } from './SideBarContext'
import { useNavigate } from 'react-router-dom'
import { Can } from 'components/Permissions'
import { SYSTEMS_CONFIG } from './constants'

const SystemBtns = () => {
    const { system } = useContext(SideBarContext)
    const navigate = useNavigate()

    const systemArr = Object.values(SYSTEMS_CONFIG)

    const changeSystem = useCallback((sys) => {
        navigate(sys.root)
    }, [])

    return (
        <SystemBtnsStyles>
            <Can I="read" an="transcription_system">
                {systemArr.map((systemBtn, index) =>
                    <IconButton key={index} aria-label="delete" onClick={() => changeSystem(systemBtn)} className={systemBtn.id == system.id ? "selected" : "unselected"} id={systemBtn.id}>
                        <SvgIcon sx={{ fontSize: "18px" }} component={systemBtn.icon} inheritViewBox />
                    </IconButton>
                )}
            </Can>
        </SystemBtnsStyles>
    )
}

export default SystemBtns